module.exports = __webpack_public_path__ + "static/assets/f68c33e731803575678cf2b2792afef5.gif";